export function firstCase(str?: string | null): string {
  if (!str) return '';
  return str[0].toUpperCase() + str.slice(1);
}

export function snakeToPascal(str?: string | null): string {
  if (!str) return '';
  return str.replaceAll('_', ' ').split(' ').map(firstCase).join(' ');
}
